import React, {useState, useEffect} from "react"
import _ from "lodash"
import { Link, navigate } from '@reach/router'

import keyService, * as chord from "data/key"

import { ShortcutHint_s } from 'styles/shortcut-styles'
import { SubnavContainer_s, Section_s, Tabs_s } from "components/subnav/subnav-styles"

type Link_t = {
  name: string
  link: string
  hard?: boolean
}

const Subnav = (props: {section: string, tabs: Array<Link_t>}) => {
  const [hintsVisible, setHintsVisible] = useState<boolean>(false)

  useEffect(() => {
    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_ALT && k.down === true:
          setHintsVisible(true)
          break
        case k.chord === chord.CTRL_ALT && k.down === false:
          setHintsVisible(false)
          break
      }

      if(_.includes(k.chord, "CTRL_ALT_")) {
        const idx = _.parseInt(_.last(k.chord)) - 1
        if(!_.isNaN(idx)) {
          const href = _.get(props.tabs, `[${idx}].link`)
          if(href) {
            if(_.includes(href, "/n/")) navigate(href)
            else window.location.assign(href)
          }
        }
      }
    })

    return function cleanup() {
      keySubscription.unsubscribe()
    }
  }, [props.tabs])

  return (
    <SubnavContainer_s id="rdcf-subnav">
      <Section_s>{props.section}</Section_s>
      <Tabs_s>
        {props.tabs.map((tab, i) => {
          if(window.location.pathname.includes(tab.link)) {
            return (
              <li key={tab.name}>
                {tab.hard ? (
                  <a className="selected" href={tab.link}>
                    {tab.name}
                  </a>
                ) : (
                  <Link className="selected" to={tab.link}>
                    {tab.name}
                  </Link>
                )}
                {hintsVisible && (
                  <ShortcutHint_s className="subnav-hint" visible={hintsVisible}>
                    {i + 1}
                  </ShortcutHint_s>
                )}
              </li>
            )
          } else {
            return (
              <li key={tab.name}>
                {tab.hard ? (
                  <a href={tab.link}>
                    {tab.name}
                  </a>
                ) : (
                  <Link to={tab.link}>
                    {tab.name}
                  </Link>
                )}
                {hintsVisible && (
                  <ShortcutHint_s className="subnav-hint" visible={hintsVisible}>
                    {i + 1}
                  </ShortcutHint_s>
                )}
              </li>
            )
          }
        })}
      </Tabs_s>
    </SubnavContainer_s>
  )
}

export default Subnav
